import { EmptyObject } from 'libs/end-to-end/src/generic';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { TopLevelAnalysisResult } from 'libs/end-to-end/src/top-level-analysis';

export const TopLevelAnalysisCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'topLevelAnalysis',
  outputFileName: 'top_level_analysis_output.json',
  isDataQueuingAllowed: false,
  outputSchema: TopLevelAnalysisResult,
  extrasSchema: EmptyObject,
  resolveFocusArea: () => null,
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'topLevelAnalysis') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
};
